exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.showcase-circle[data-v-2b2830b6] {\n  position: relative;\n  width: 5.2rem;\n  height: 5.2rem;\n  border-radius: 50%;\n  z-index: 100;\n  margin: 15% auto 0;\n  border: 0.2rem solid #aa153d;\n}\n.product-name[data-v-2b2830b6],\n.sub-product-name[data-v-2b2830b6] {\n  text-align: center;\n  color: #ffffff;\n  margin-top: 0.2rem;\n}\n.product-name[data-v-2b2830b6] {\n  font-size: 20px;\n}\n.sub-product-name[data-v-2b2830b6] {\n  font-size: 16px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-2b2830b6","scoped":true,"hasInlineConfig":true}!./~/_less-loader@4.0.5@less-loader/dist/cjs.js?{"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/views/pack/swiper-card.vue
// module id = 713
// module chunks = 1